import LoadingSpinner, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";

const LoadingIndicator = (props: CircularProgressProps) => {
  return <LoadingSpinner {...props} />;
};

export default LoadingIndicator;
